import { memo } from 'react';
import { helpCenterUrl } from '../../config.ts';

export const OldPlaylistsPage = memo(() => {
  const handleViewLegacyPlaylists = () => {
    // Navigate to old music page or external link
    window.open('https://account.napster.com/account/login', '_blank');
  };

  const handleContactSupport = () => {
    // Add support contact logic here
    window.open(helpCenterUrl, '_blank');
  };

  return (
    <div className="h-full text-left !fixed !w-screen !left-0 bg-black !inset-0 opacity-100 !z-[1000]">
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-white/10 to-white/0" />

      <div className="sm:px-6 lg:px-8 py-8 overflow-y-auto h-full relative pb-60">
        <div className="fixed inset-0 w-full h-full bg-gradient-to-b from-white/10 to-white/0 -z-[1]" />
        <div className="bg-transparent transition-colors max-w-4xl mx-auto relative">
          <div className="mx-auto pt-10 px-5 sm:px-6 lg:px-8">
            <div className="mb-16">
              <h1 className="text-5xl font-bold mb-4 text-white">
                Where are my playlists?
              </h1>
              <p className="text-xl text-gray-400">
                You haven't lost them — you just can't play them in the new
                Napster app.
              </p>
            </div>
            <section className="mb-16">
              <h2 className="text-3xl font-bold mb-6 text-white">
                What changed
              </h2>
              <div
                className="rounded-2xl p-8"
                style={{
                  background:
                    'var(--backgrounds-glass-fill, rgba(128, 128, 128, 0.30))',
                  backdropFilter: 'blur(73.62557220458984px)',
                  borderTop:
                    '1px solid var(--backgrounds-glass-stroke, rgba(255, 255, 255, 0.40))',
                }}>
                <p className="text-gray-300 leading-relaxed mb-4">
                  Napster is no longer a music streaming service. We've become
                  an AI platform for creating and experiencing music in new
                  ways. That means the streaming catalog and playlists from the
                  old app won't work here.
                </p>
                <p className="text-gray-300 leading-relaxed">
                  We know this can be frustrating, especially if you spent years
                  building your playlists. To make things easier, you can export
                  all your Napster playlists in just a few clicks.
                </p>
              </div>
            </section>
            <section className="mb-16">
              <h2 className="text-3xl font-bold mb-6 text-white">
                Where to find your old playlists
              </h2>
              <div
                className="rounded-2xl p-8"
                style={{
                  background:
                    'var(--backgrounds-glass-fill, rgba(128, 128, 128, 0.30))',
                  backdropFilter: 'blur(73.62557220458984px)',
                  borderTop:
                    '1px solid var(--backgrounds-glass-stroke, rgba(255, 255, 255, 0.40))',
                }}>
                <p className="text-gray-300 leading-relaxed mb-6">
                  Your previous playlists are still linked to your account and
                  available in a separate view.
                </p>
                <button
                  onClick={handleViewLegacyPlaylists}
                  className="w-full sm:w-auto bg-white text-black font-semibold px-8 py-4 rounded-full hover:bg-gray-100 transition-colors flex items-center justify-center gap-2">
                  View my legacy playlists
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="w-5 h-5">
                    <path d="m9 18 6-6-6-6"></path>
                  </svg>
                </button>
              </div>
            </section>

            <section className="mb-16">
              <h2 className="text-3xl font-bold mb-6 text-white">
                Export my playlists
              </h2>
              <div
                className="rounded-2xl p-8"
                style={{
                  background:
                    'var(--backgrounds-glass-fill, rgba(128, 128, 128, 0.30))',
                  backdropFilter: 'blur(73.62557220458984px)',
                  borderTop:
                    '1px solid var(--backgrounds-glass-stroke, rgba(255, 255, 255, 0.40))',
                }}>
                <p className="text-gray-300 leading-relaxed mb-6">
                  You can export your legacy playlists and import them into your
                  preferred music service, like Spotify, Apple Music, YouTube
                  Music, and others.
                </p>
                <a
                  href="https://www.tunemymusic.com/?mode=napsterexp&fsource=napster"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-fit bg-white text-black font-semibold px-8 py-4 rounded-full hover:bg-gray-100 transition-colors flex items-center justify-center gap-2">
                  Export my legacy playlists
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="w-5 h-5">
                    <path d="m9 18 6-6-6-6"></path>
                  </svg>
                </a>
              </div>
            </section>

            <section className="mb-16">
              <div
                className="rounded-2xl p-8 text-center"
                style={{
                  background:
                    'var(--backgrounds-glass-fill, rgba(128, 128, 128, 0.30))',
                  backdropFilter: 'blur(73.62557220458984px)',
                  borderTop:
                    '1px solid var(--backgrounds-glass-stroke, rgba(255, 255, 255, 0.40))',
                }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-help-circle w-12 h-12 mx-auto mb-4 text-gray-400">
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                  <path d="M12 17h.01"></path>
                </svg>
                <h2 className="text-2xl font-bold mb-4 text-white">
                  Need help?
                </h2>
                <p className="text-gray-300 mb-6 max-w-2xl mx-auto">
                  If you have questions or trouble with the migration, we're
                  here.
                </p>
                <button
                  onClick={handleContactSupport}
                  className="bg-[#252525] text-white font-semibold px-8 py-4 rounded-full hover:bg-[#2a2a2a] transition-colors border border-gray-700">
                  Contact support
                </button>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
});

OldPlaylistsPage.displayName = 'OldPlaylistsPage';

export default OldPlaylistsPage;
